export const CarpetasAdjuntos = {
    ImagenLogin: 'LoginImage'
}
